import { useEffect, useState } from 'react'
import ActionArea from '../../components/ActionArea'
import Head from '../../components/Head'
import List from '../../components/List'
import SelectInput from '../../components/UI/SelectInput'
import Input from "../../components/UI/Input";
import { IUserRequest, Iusers } from './types'
import userStatus from '../../utils/userStatus'
import AccountsTableButtons from '../../components/AccountsTableActions'
import { useNavigate  } from 'react-router-dom'
import { getUsersList } from '../../services/users'
import { getPermission } from '../../services/permisssion'
import permissionType from '../../utils/permissionType'
import { message, Tag } from 'antd'
import React from 'react'
import direction from '../../utils/filterDirectionOrder'
import SmartSearch from '../../components/UI/SmartSearch'
import { notificationError } from '../../services/notification'
import { useLoading } from '../../context/LoadingProvider/useLoading'
import { sendSystemLog, useAuth } from '../../context/AuthProvider/useAuth'

function Accounts(props:{accessLevel: string}) {
  const log = {
    log_type: 'visited',
    log_object: 'account'
  }
  const {canEdit} = useAuth()
  const loading = useLoading()
  const selectOptions = [
    {name: 'All', value: 'All'},
    {name: userStatus.active, value: userStatus.active},
    {name: userStatus.inactive, value: userStatus.inactive},
  ]
  const [users, setUsers] = useState<IUserRequest>({
    count: 0,
    list:[{
        id: 1,
        name: "",
        affiliation: "",
        company: "",
        email: "",
        phone: "",
        status: "",
        canEdit: "Yes",
    }],
    page: null,
    perpage:0
  })
  const [filter, setFilter] = useState<any>({
    filter: selectOptions[0].value,
    fieldOrder: '',
    directionOrder: '',
    userSearch: "",
    search: {
      id: null,
      name: '',
      type: '',
    }
  })
  const history = useNavigate()

  useEffect(() => {
    sendSystemLog(log);
  }, []);

  useEffect(() => {
    (async() =>{
      loading.addLoading()
      await getUserAccounts()
      loading.removeLoading()
    })()
  },[])

  const getStatusLabel = (status: string) => {
    if(status === userStatus.active) {
      return <Tag color="green">{status}</Tag>
    } 
    if(status === userStatus.inactive ) {
      return <Tag color="red">{status}</Tag>
    }
  }

  const getAffiliationLabel = (value: string) => {
      switch (value) {
          case 'organization':
              return 'Charity'
          case 'manufacturer':
              return 'Manufacturer'
          case 'distributor':
              return 'Distributor'
          case 'location':
              return 'Location'
          case 'investigator':
              return 'Investigator'
          default:
              break
      }
  }

  const onChangeOrder = async (order: {column: any, field: string, order: string| undefined}) => {
    loading.addLoading()
    let newFilter = {
      status: filter.filter,
      userSearch: filter.userSearch ? filter.userSearch : '',
      fieldOrder: '',
      directionOrder: '',
    }
    if(order.column) {
     newFilter = {
      ...newFilter,
      status: filter.filter,
      userSearch: filter.userSearch ? filter.userSearch : '',
      fieldOrder: order.field,
      directionOrder: order.order === 'ascend' ? direction.asc : direction.desc,
     }

    }
    const userList = await getUsersList(newFilter)
    setFilter({
      ...filter,
      filter: filter.filter,
      userSearch: filter.userSearch ? filter.userSearch : '',
      fieldOrder: order.field || '',
      directionOrder:  (order.order === 'ascend' ? direction.asc : direction.desc) || '',
    })
    setUsers(userList)
    loading.removeLoading()
  }

  const getUserAccounts = async() => {
    loading.addLoading()
    let newFilter = {
      status: filter.filter,
      userSearch: filter.userSearch ? filter.userSearch : '',
      fieldOrder: filter.fieldOrder,
      directionOrder: filter.directionOrder,
    }
    const userList = await getUsersList(newFilter)
    setUsers(userList)
    loading.removeLoading()
  }

  return (
    <div className="accounts">
      <Head
        id={'new-account-button'}
        title="All Accounts"
        buttonText="New Account"
        buttonAction={() => history('../users/new')}
        disabled={!canEdit}
    />
    <meta name="viewport" content="width=device-width, initial-scale=.75"/>

    <ActionArea innerProps={{id: 'accounts_refresh'}} buttonAction={getUserAccounts} buttonText={'Search'}>
        <>
          <SelectInput 
            options={selectOptions} 
            label='Status'
            onSelectChange={(e) => setFilter({...filter, filter: e?.value ? e.value : e})}
            value={filter.filter}
            innerProps={{id: 'accounts_status'}}
            style={{marginBottom: 0}}
          />
          <Input
            label="User Search"
            onChange={(e: any) => setFilter({ ...filter, userSearch: e.target.value })}
            value={filter.userSearch}
            style={{marginBottom: 0}}
          />
        </>
      </ActionArea>
      <List
        rows={users.list || []}
        onChange={(selectedRowKeys, selectedRows, order) => onChangeOrder(order)}
        columns={[
          {
            title: 'Name',
            dataIndex: 'name',
            key: 'name',
            render: (value: string) => value,
            sorter: true,
            width: 100
          },
          {
            title: 'Affiliation',
            dataIndex: 'affiliation',
            key: 'affiliation',
            render: (value: string) => getAffiliationLabel(value),
            sorter: true,
            width: 100
          },
          {
            title: 'Company',
            dataIndex: 'company',
            key: 'company',
            render: (value: string) => value,
            sorter: true,
            width: 100
          },
          {
            title: 'Email',
            dataIndex: 'email',
            key: 'email',
            render: (value: string) => value,
            sorter: true,
            width: 100
          },
          {
            title: 'Phone',
            dataIndex: 'phone',
            key: 'phone',
            render: (value: string) => value,
            sorter: true,
            width: 75
          },
          {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
            render: (value: string) => getStatusLabel(value),
            sorter: true,
            width: 50
          },
          {
            title: 'Actions',
            render: (value: Iusers, record: any, index: number) => <AccountsTableButtons index={index} user={value} disabled={!canEdit} onChangeStatus={getUserAccounts}/>,
            width: 100
          },
        ]}
      />
    </div>
  )
}

export default Accounts

